import { Avatar, Col, useTheme } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";
import { useFace } from "../../me/face.ts";
import { usePresent } from "../../push/here.ts";
import type { Person } from "../composer/saying.ts";
import { type Busy, middleTruncated } from "./doing.ts";

export function nameFor(
  row: { account: string; handle: string; displayName: string | null },
  known: Map<string, Person>,
): string {
  return calledBy(known.get(row.account)) ?? calledBy(row) ?? row.handle;
}

export function Face({ row, known, size }: { row: Busy; known: Map<string, Person>; size: number }) {
  const face = useFace(known.get(row.account)?.avatar ?? null);
  return <Avatar name={nameFor(row, known)} src={face} size={size} present={usePresent(row.account)} />;
}

export function saidOf(row: Busy, most: number): string {
  if (row.why) return say("busy.stopping");
  const verb = say(`busy.${row.verb}` as const);
  return row.object ? `${verb} ${middleTruncated(row.object, most)}` : verb;
}

export function LiveDot({ on }: { on: boolean }) {
  const theme = useTheme();
  if (!on) return null;
  return <Col style={{ width: 6, height: 6, borderRadius: 999, backgroundColor: theme.color.accent }} />;
}
